export default "__VITE_ASSET__BGNTr7ue__"